
<template>
  <div class="flex min-h-screen bg-primaryBg font-inter">
    <aside class="hidden md:block w-[294px] flex-shrink-0 bg-primaryBg text-primaryDark">
      <Sidebar />
    </aside>

    <div class="flex-grow">
      <main class="w-full px">
        <ProjectsComponent />
      </main>
    </div>
  </div>
</template>

<script>
import ProjectsComponent from '@/components/project/ProjectsComponent.vue';
import Sidebar from '@/components/SidebarComponent.vue';
// import Navbar from '@/components/NavbarComponent.vue';

export default {
  name: 'ProjectsView',
  components: {
    ProjectsComponent,
    Sidebar,
    // Navbar,
  },
  mounted() {
    window.scrollTo(0, 0);
    },
};
</script>

<style scoped>
/* Ensure full height and consistent layout */
html,
body {
  margin: 0;
  height: 100%;
}
</style>

